import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions';
import FhqHelpContactsService from '@services/fhq-help-contacts';
import { FhqHelpContact, FhqHelpContactCreateDto, FhqHelpContactUpdateDto } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchFhqHelpContactsAsync(action: { payload: IdType }) {
  try {
    const fhqHelpContacts: FhqHelpContact[] = yield call(FhqHelpContactsService.getListBySiteFhqId, action.payload);

    yield put(actions.fetchFhqHelpContacts.success({ siteFhqId: action.payload, items: fhqHelpContacts }));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchFhqHelpContacts.failure(error));
  }
}

function* watchFetchFhqHelpContacts() {
  yield takeLatest(actions.fetchFhqHelpContacts.request, fetchFhqHelpContactsAsync);
}

// create
function* createFhqHelpContactsAsync(action: { payload: FhqHelpContactCreateDto }) {
  try {
    const fhqHelpContact: FhqHelpContact = yield call(FhqHelpContactsService.create, action.payload);

    yield put(actions.createFhqHelpContact.success({ data: fhqHelpContact, siteFhqId: action.payload.siteFhqId }));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.createFhqHelpContact.failure(error));
  }
}

function* watchCreateFhqHelpContact() {
  yield takeLatest(actions.createFhqHelpContact.request, createFhqHelpContactsAsync);
}

// update
function* updateFhqHelpContactsAsync(action: {
  payload: { siteFhqId: IdType; id: IdType; data: FhqHelpContactUpdateDto };
}) {
  try {
    const fhqHelpContact: FhqHelpContact = yield action.payload.id
            && call(FhqHelpContactsService.update, action.payload.id, action.payload.data);

    yield put(actions.updateFhqHelpContact.success({ siteFhqId: action.payload.siteFhqId, data: fhqHelpContact }));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateFhqHelpContact.failure(error));
  }
}

function* watchUpdateFhqHelpContacts() {
  yield takeLatest(actions.updateFhqHelpContact.request, updateFhqHelpContactsAsync);
}

// delete
function* deleteFhqHelpContactsAsync(action: { payload: IdType }) {
  try {
    yield call(FhqHelpContactsService.delete, action.payload);
    yield put(actions.deleteFhqHelpContact.success(action.payload));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.deleteFhqHelpContact.failure(error));
  }
}

function* watchDeleteFhqHelpContacts() {
  yield takeLatest(actions.deleteFhqHelpContact.request, deleteFhqHelpContactsAsync);
}

// all
function* watchFhqHelpContacts(): SagaGenerator {
  yield all([
    watchFetchFhqHelpContacts(),
    watchCreateFhqHelpContact(),
    watchUpdateFhqHelpContacts(),
    watchDeleteFhqHelpContacts(),
  ]);
}

export default watchFhqHelpContacts;
